import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';
import socket from 'config/socket';

import {
  GET_SALES_ORDERS, ADD_SALES_ORDER, REFUND_SALES_ORDER, SHALLOW_DELETE_SALES_ORDER
} from 'redux/actionTypes';
import { incrementIDGen, incrementCustomerPayable, decrementCustomerPayable, incrementProductQuantities, decrementProductQuantities } from '.';
import { salesOrder } from 'variables/idGenType';
import { standard } from 'variables/userAccountTypes';
import { credit } from 'variables/paymentMethods';

export const getSalesOrders = () => (dispatch, getState) => {
  axiosClient
    .get('/api/salesOrders', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_SALES_ORDERS,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const getSalesOrdersAdmin = () => (dispatch, getState) => {
  axiosClient
    .get('/api/salesOrders/admin', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_SALES_ORDERS,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addSalesOrder = (newSalesOrder, userId, adminId) => (dispatch, getState) => {
  axiosClient
    .post('/api/salesOrders', newSalesOrder, tokenConfig(getState))
    .then(res => {
      const updatedProducts = res.data.products.map(product => ({
        id: product.productId,
        decrementQuantity: product.quantity
      }));

      dispatch(incrementIDGen({ id: userId, field: salesOrder }));
      dispatch(decrementProductQuantities(updatedProducts));
      if(res.data.paymentMethod === credit) dispatch(incrementCustomerPayable({ id: res.data.customerId, incrementAmount: res.data.total }));
      dispatch({
        type: ADD_SALES_ORDER,
        payload: res.data
      });
      //socket will only emit for standard users.
      if(getState().activeUserType === standard) {
        socket.emit('private-request', {
          request: 'add-sales-order',
          userId: adminId,
          data: res.data
        });
      }
    })
    .catch(err => console.log(err))
};

export const addSalesOrderSocket = newSalesOrder => ({
  type: ADD_SALES_ORDER,
  payload: newSalesOrder
});

export const refundSalesOrder = (refundedSalesOrder, updates, adminId) => (dispatch, getState) => {
  axiosClient
    .patch('/api/salesOrders/refund', refundedSalesOrder, tokenConfig(getState))
    .then(res => {
      dispatch(incrementProductQuantities(updates.updatedProducts));
      if(updates.paymentMethod === credit) dispatch(decrementCustomerPayable({ id: updates.customerId, decrementAmount: updates.decrementAmount }));
      dispatch({
        type: REFUND_SALES_ORDER,
        payload: res.data
      });
      //socket will only emit for standard users.
      if(getState().activeUserType === standard) {
        socket.emit('private-request', {
          request: 'refund-sales-order',
          userId: adminId,
          data: res.data
        });
      }
    })
    .catch(err => console.log(err))
};

export const refundSalesOrderSocket = refundedSalesOrder => ({
  type: REFUND_SALES_ORDER,
  payload: refundedSalesOrder
});

export const deleteSalesOrder = (id, updates, adminId) => (dispatch, getState) => {
  axiosClient
    .delete('/api/salesOrders/shallow', { params: { id }, ...tokenConfig(getState) })
    .then(res => {
      if(res.status === 204) {
        const updatedProducts = updates.products.map(product => ({
          id: product.productId,
          incrementQuantity: product.quantity
        }));

        dispatch(incrementProductQuantities(updatedProducts));
        if(updates.paymentMethod === credit) dispatch(decrementCustomerPayable({ id: updates.customerId, decrementAmount: updates.decrementAmount }));
        dispatch({
          type: SHALLOW_DELETE_SALES_ORDER,
          payload: { id }
        });
        //socket will only emit for standard users.
        if(getState().activeUserType === standard) {
          socket.emit('private-request', {
            request: 'delete-sales-order',
            userId: adminId,
            data: id
          });
        }
      }
    })
    .catch(err => console.log(err))
};

export const deleteSalesOrderSocket = id => ({
  type: SHALLOW_DELETE_SALES_ORDER,
  payload: { id }
});